import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import MachineryApplicationContent from './MachineryApplicationContent';
import MachineryApplicationModal from '../modals/edit-application/MachineryApplicationModal';

const form = {
  keyword: '',
};

function MachineryApplicationContainer({
  match,
  history,
  getMachineryApplicationsList,
  applicationList,
  isLoading,
  applicationListPager,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <MachineryApplicationModal id={data.id} applicationInfo={data} />
      ),
      title: 'Update Machinery Application',
      modalSize: 'modal-xl',
    });
  };

  useEffect(() => {
    getMachineryApplicationsList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getMachineryApplicationsList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:applicationId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Machinery Applications"
            getData={getMachineryApplicationsList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:applicationId?`}
            listName="ApplicationCodes"
            label="Machinery Applications"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.tdn')}</div>
            )}
            noRightCard
            isLoading={isLoading}
            selected={params.applicationId}
            data={applicationList}
            dataPager={applicationListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:applicationId?`}
                    render={() => (
                      <MachineryApplicationContent
                        handleEdit={handleEdit}
                        listIsLoading={isLoading}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:applicationId?`}
                  render={() =>
                    !params.applicationId && applicationList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(applicationList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

MachineryApplicationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getMachineryApplicationsList: PropTypes.instanceOf(Function).isRequired,
  applicationList: PropTypes.instanceOf(Array).isRequired,
  applicationListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  applicationList: _.get(api, `${c.GET_MACHINERY_APPLICATIONS}.list`) || [],
  applicationListPager:
    _.get(api, `${c.GET_MACHINERY_APPLICATIONS}.pager`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_APPLICATIONS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachineryApplicationContainer);
